import { useMemo } from "react";
import { useApp } from "../context/AppContext";
import projects from "../data/projects";

/**
 * useProjects — returns the full list of projects with content
 * in the currently active locale.
 */
export function useProjects() {
  const { locale } = useApp();

  return useMemo(
    () =>
      projects.map((p) => ({
        id: p.id,
        image: p.image,
        liveUrl: p.liveUrl,
        githubUrl: p.githubUrl,
        publishDate: p.publishDate,
        // Merge localised content into the top level
        ...p[locale],
      })),
    [locale]
  );
}

/**
 * useProject(id) — returns a single project by its id slug,
 * or null if not found.
 */
export function useProject(id) {
  const all = useProjects();
  return useMemo(() => all.find((p) => p.id === id) ?? null, [all, id]);
}
